import hdiLoader from 'assets/icons/hdiLoader.svg';
import loader from 'assets/icons/loader.svg';
import React from 'react';
import styles from './LibertyLoader.module.scss';

const LibertyLoader = () => {
  return (
    <div className={styles.loaderContainer}>
      <img className={styles.hdiLoader} src={hdiLoader} alt="hdiLoader" />
      <img className={styles.loader} src={loader} alt="loader" />
    </div>
  );
};

export default LibertyLoader;
